export default __webpack_public_path__ + "static/media/lull.a6445851.png";